(function() {
  'use strict';

  if (window.__NEQuickViewDiscountBadgeAllPagesV4) return;
  window.__NEQuickViewDiscountBadgeAllPagesV4 = true;

  var timer = null;
  var discountCache = {};
  var pendingDiscounts = {};
  var cacheGeneration = 0;
  var productCache = {};

  var scriptConfig = document.currentScript;
  var forceQuickViewBadgeToImageTopLeft = Boolean(
    scriptConfig && scriptConfig.dataset.forceImageTopLeft === 'true'
  );

  function normalizeCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function parseMoney(text) {
    text = String(text || '')
      .replace(/\s/g, '')
      .replace(/[^\d,.]/g, '');

    if (!text) return 0;

    if (text.indexOf(',') > -1) {
      text = text.replace(/\./g, '').replace(',', '.');
    }

    return Number(text || 0);
  }

  function formatPrice(price) {
    return window.NE.Utils.formatMoney(Math.round(Number(price || 0) * 100));
  }

  function isVisible(element) {
    if (!element) return false;

    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0'
    );
  }

  function getQuickViewModals() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.quick-product--wrap[data-quick-view-modal], .quick-product--wrap')
    ).filter(function(modal) {
      return isVisible(modal);
    });
  }

  function getActiveDiscountDetails() {
    if (
      window.NE &&
      window.NE.DiscountTracker &&
      typeof window.NE.DiscountTracker.getDetails === 'function'
    ) {
      try {
        var details = window.NE.DiscountTracker.getDetails();

        if (details && details.code) {
          return {
            code: normalizeCode(details.code),
            percentage: Number(details.percentage || 0)
          };
        }
      } catch (e) {}
    }

    try {
      var cached = sessionStorage.getItem('ne_discount_details');

      if (cached) {
        var parsed = JSON.parse(cached);

        if (parsed && parsed.code) {
          return {
            code: normalizeCode(parsed.code),
            percentage: Number(parsed.percentage || 0)
          };
        }
      }
    } catch (e) {}

    try {
      var storedCode = sessionStorage.getItem('ne_discount_code');

      if (storedCode) {
        return {
          code: normalizeCode(storedCode),
          percentage: 0
        };
      }
    } catch (e) {}

    try {
      var cookieMatch = document.cookie.match(/(?:^|;\s*)ne_discount_code=([^;]+)/);

      if (cookieMatch && cookieMatch[1]) {
        return {
          code: normalizeCode(decodeURIComponent(cookieMatch[1])),
          percentage: 0
        };
      }
    } catch (e) {}

    try {
      var params = new URLSearchParams(window.location.search || '');
      var paramCode = params.get('ne_coupon');
      var vanityHandoffCode = sessionStorage.getItem('ne_vanity_discount');

      if (
        paramCode &&
        vanityHandoffCode &&
        normalizeCode(paramCode) === normalizeCode(vanityHandoffCode)
      ) {
        return {
          code: normalizeCode(paramCode),
          percentage: 0
        };
      }
    } catch (e) {}

    return null;
  }

  function getProductIdFromModal(modal) {
    if (!modal) return null;

    var holder =
      modal.querySelector('.quick-product[data-product-id]') ||
      modal.querySelector('.quick-view-modal__content[data-product-id]') ||
      modal.querySelector('[data-is-quick-view][data-product-id]');

    if (holder) {
      return holder.getAttribute('data-product-id') || holder.getAttribute('data-productId');
    }

    var addToCartButton = modal.querySelector('[data-add-to-cart][data-id]');

    if (addToCartButton && addToCartButton.getAttribute('data-id')) {
      return addToCartButton.getAttribute('data-id');
    }

    return null;
  }

  function getProductHandleFromModal(modal) {
    if (!modal) return '';

    var holder =
      modal.querySelector('.quick-product[data-product-handle]') ||
      modal.querySelector('.quick-view-modal__content[data-product-handle]') ||
      modal.querySelector('[data-product-handle]');

    if (holder && holder.getAttribute('data-product-handle')) {
      return holder.getAttribute('data-product-handle');
    }

    var form = modal.querySelector('[data-product-form][data-product-handle]');

    if (form && form.getAttribute('data-product-handle')) {
      return form.getAttribute('data-product-handle');
    }

    var productLink = modal.querySelector('a[href*="/products/"]');

    if (productLink) {
      try {
        var url = new URL(productLink.getAttribute('href'), window.location.origin);
        var match = url.pathname.match(/\/products\/([^/?#]+)/);

        if (match && match[1]) return match[1];
      } catch (e) {}
    }

    return '';
  }

  function fetchProductByHandle(handle) {
    handle = String(handle || '').trim();

    if (!handle) return Promise.resolve(null);

    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }

    return fetch('/products/' + handle + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.json();
      })
      .then(function(product) {
        productCache[handle] = product;
        return product;
      })
      .catch(function() {
        productCache[handle] = null;
        return null;
      });
  }

  function getProductIdAsync(modal) {
    var productId = getProductIdFromModal(modal);

    if (productId) {
      return Promise.resolve(productId);
    }

    return fetchProductByHandle(getProductHandleFromModal(modal)).then(function(product) {
      return product && product.id ? product.id : null;
    });
  }

  function fetchProductDiscount(code, productId) {
    code = normalizeCode(code);
    productId = String(productId || '').trim();

    if (!code || !productId) return Promise.resolve(0);

    var cacheKey = code + ':' + productId;

    if (Object.prototype.hasOwnProperty.call(discountCache, cacheKey)) {
      return Promise.resolve(discountCache[cacheKey]);
    }

    if (pendingDiscounts[cacheKey]) {
      return pendingDiscounts[cacheKey];
    }

    if (
      window.NE &&
      window.NE.DiscountTracker &&
      typeof window.NE.DiscountTracker.fetchProductDiscount === 'function'
    ) {
      var generation = cacheGeneration;
      var request = window.NE.DiscountTracker.fetchProductDiscount(code, productId)
        .then(function(percentage) {
          if (generation !== cacheGeneration) return null;
          percentage = Number(percentage || 0);
          discountCache[cacheKey] = percentage;
          return percentage;
        })
        .catch(function() {
          if (generation !== cacheGeneration) return null;
          discountCache[cacheKey] = 0;
          return 0;
        })
        .then(function(percentage) {
          if (pendingDiscounts[cacheKey] === request) {
            delete pendingDiscounts[cacheKey];
          }

          return percentage;
        });

      pendingDiscounts[cacheKey] = request;
      return request;
    }

    return Promise.resolve(0);
  }

  function isButtonPriceElement(priceElement) {
    return !!(
      priceElement &&
      priceElement.closest(
        'button, .button, [type="submit"], .product-form__cart-submit, .add-to-cart, [data-add-to-cart], [data-submit-button]'
      )
    );
  }

  function restoreButtonPrices(modal) {
    if (!modal) return;

    modal.querySelectorAll('[data-price]').forEach(function(priceElement) {
      if (!isButtonPriceElement(priceElement)) return;

      if (priceElement.hasAttribute('data-ne-qv-original-html')) {
        priceElement.innerHTML = priceElement.getAttribute('data-ne-qv-original-html');
        priceElement.removeAttribute('data-ne-qv-original-html');
        priceElement.removeAttribute('data-ne-qv-discount-price');
        priceElement.removeAttribute('data-ne-qv-discount-signature');
      }
    });
  }

  function getPriceElements(modal) {
    if (!modal) return [];

    return Array.prototype.slice.call(
      modal.querySelectorAll(
        '.product__price-wrapper--compare-price span[data-price], ' +
        '.product__price-wrapper span[data-price], ' +
        '.product__price span[data-price], ' +
        '[data-price]'
      )
    ).filter(function(priceElement) {
      if (!priceElement || !priceElement.hasAttribute('data-price')) return false;
      if (isButtonPriceElement(priceElement)) return false;

      if (priceElement.closest('.unit-price, .product-item__unit-price, [data-unit-price-container]')) {
        return false;
      }

      return true;
    });
  }

  function restorePrice(priceElement) {
    if (!priceElement) return;

    if (priceElement.hasAttribute('data-ne-qv-original-html')) {
      priceElement.innerHTML = priceElement.getAttribute('data-ne-qv-original-html');
      priceElement.removeAttribute('data-ne-qv-original-html');
      priceElement.removeAttribute('data-ne-qv-discount-price');
      priceElement.removeAttribute('data-ne-qv-discount-signature');
    }
  }

  function renderPrice(priceElement, percentage, code) {
    if (!priceElement || !percentage || percentage <= 0) {
      restorePrice(priceElement);
      return;
    }

    if (isButtonPriceElement(priceElement)) {
      restorePrice(priceElement);
      return;
    }

    var priceValue = priceElement.getAttribute('data-price');
    if (!priceValue) return;

    var originalPrice = parseFloat(String(priceValue).replace(',', '.'));
    if (!originalPrice || isNaN(originalPrice)) return;

    if (!priceElement.hasAttribute('data-ne-qv-original-html')) {
      priceElement.setAttribute('data-ne-qv-original-html', priceElement.innerHTML);
    }

    var discountedPrice = originalPrice - (originalPrice * percentage / 100);
    var signature = normalizeCode(code) + '|' + originalPrice + '|' + percentage;

    if (
      priceElement.getAttribute('data-ne-qv-discount-signature') === signature &&
      priceElement.getAttribute('data-ne-qv-discount-price') === 'true'
    ) {
      return;
    }

    priceElement.innerHTML =
      '<span class="ne-discount-price-wrapper">' +
        '<span class="ne-discount-price__discounted">' + formatPrice(discountedPrice) + '</span>' +
        '<span class="ne-discount-price__original">' + formatPrice(originalPrice) + '</span>' +
      '</span>';

    priceElement.setAttribute('data-ne-qv-discount-price', 'true');
    priceElement.setAttribute('data-ne-qv-discount-signature', signature);
  }

  function getVisibleReducedPricePercentage(modal) {
    if (!modal) return 0;

    var wrappers = modal.querySelectorAll(
      '.ne-discount-price-wrapper, ' +
      '.product__price-wrapper, ' +
      '.product__price, ' +
      '.product__price-quantity-wrapper'
    );

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];

      if (!isVisible(wrapper)) continue;
      if (wrapper.closest('button, .button, [type="submit"]')) continue;

      var discountedEl =
        wrapper.querySelector('.ne-discount-price__discounted') ||
        wrapper.querySelector('.sale-price') ||
        wrapper.querySelector('.sale') ||
        wrapper.querySelector('[data-discount-price]');

      var originalEl =
        wrapper.querySelector('.ne-discount-price__original') ||
        wrapper.querySelector('s') ||
        wrapper.querySelector('del') ||
        wrapper.querySelector('[data-compare-price]');

      if (!discountedEl || !originalEl) continue;
      if (!isVisible(discountedEl) || !isVisible(originalEl)) continue;

      var discounted = parseMoney(discountedEl.textContent);
      var original = parseMoney(originalEl.textContent);

      if (original > discounted && discounted > 0) {
        return Math.round(((original - discounted) / original) * 100);
      }
    }

    return 0;
  }

   function getQuickProductLeft(modal) {
    if (!modal) return null;

    return (
      modal.querySelector('.quick-product--left') ||
      modal.querySelector('.product__media') ||
      modal.querySelector('.product__media-container') ||
      modal.querySelector('.product__media-wrapper') ||
      modal.querySelector('.quick-product__media') ||
      modal.querySelector('.quick-view__media')
    );
  }

  function getModalPositionRoot(modal) {
    if (forceQuickViewBadgeToImageTopLeft) {
      return getQuickProductLeft(modal);
    }

    return (
      modal.querySelector('.quick-product--modal__inner') ||
      modal.querySelector('.modal__inner') ||
      modal.querySelector('.quick-view-modal__content') ||
      modal
    );
  }

  function getQuickViewStackBadge(modal) {
    if (!modal) return null;

    var searchRoot = forceQuickViewBadgeToImageTopLeft
      ? getQuickProductLeft(modal)
      : modal;

    if (!searchRoot) return null;

    var badges = searchRoot.querySelectorAll(
      '.product_badge_container, ' +
      '.product-badge__wrapper, ' +
      '.product-badge__wrapper-sale, ' +
      '.product-badges, ' +
      '.product-item__badge, ' +
      '[data-badge]'
    );

    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      var text = badge ? String(badge.textContent || '').trim().toUpperCase() : '';

      if (!badge) continue;
      if (badge.hasAttribute('data-ne-qv-discount-badge')) continue;
      if (badge.closest('[data-ne-qv-discount-badge]')) continue;
      if (text.indexOf('%') !== -1) continue;
      if (!isVisible(badge)) continue;

      if (
        text.indexOf('BESTSELLER') !== -1 ||
        text.indexOf('NEU') !== -1 ||
        text.indexOf('NEW') !== -1 ||
        text.length > 0
      ) {
        return badge;
      }
    }

    return null;
  }

  function getImagePositionInRoot(modal, positionRoot) {
    if (!positionRoot) {
      return {
        top: 8,
        left: 8
      };
    }

    if (forceQuickViewBadgeToImageTopLeft) {
      return {
        top: 8,
        left: 8
      };
    }

    var image = Array.prototype.slice.call(positionRoot.querySelectorAll('img')).filter(function(img) {
      if (!isVisible(img)) return false;

      var rect = img.getBoundingClientRect();

      return rect.width > 120 && rect.height > 120;
    })[0];

    if (!image) {
      return {
        top: 8,
        left: 8
      };
    }

    var rootRect = positionRoot.getBoundingClientRect();
    var imageRect = image.getBoundingClientRect();

    return {
      top: Math.round(imageRect.top - rootRect.top + 8),
      left: Math.round(imageRect.left - rootRect.left + 8)
    };
  }

  function removeWrongQuickViewBadges(modal, keepBadge) {
    if (!modal) return;

    modal.querySelectorAll(
      '[data-ne-qv-below-bestseller-badge], ' +
      '[data-ne-quick-view-discount-badge], ' +
      '[data-pdp-discount-product-badge], ' +
      '.ne-discount-product-badge[data-discount-product-badge]'
    ).forEach(function(badge) {
      if (badge !== keepBadge && !badge.hasAttribute('data-ne-qv-discount-badge')) {
        badge.remove();
      }
    });
  }

  function ensureDiscountBadge(modal) {
    if (!modal) return null;

    var positionRoot = getModalPositionRoot(modal);
    if (!positionRoot) return null;

    if (window.getComputedStyle(positionRoot).position === 'static') {
      positionRoot.style.position = 'relative';
    }

    var existing = modal.querySelector('[data-ne-qv-discount-badge]');

    if (existing) {
      if (existing.parentElement !== positionRoot) {
        positionRoot.insertBefore(existing, positionRoot.firstChild);
      }

      return existing;
    }

    var badge = document.createElement('div');

    badge.className = 'ne-discount-product-badge';
    badge.setAttribute('data-ne-qv-discount-badge', '');
    badge.setAttribute('aria-hidden', 'true');

    badge.innerHTML =
      '<span class="ne-discount-product-badge__text">-' +
        '<span data-percentage-value></span>%' +
      '</span>';

    positionRoot.insertBefore(badge, positionRoot.firstChild);

    return badge;
  }

  function hideDiscountBadge(modal) {
    if (!modal) return;

    modal.querySelectorAll('[data-ne-qv-discount-badge]').forEach(function(badge) {
      badge.classList.remove('is-visible');
      badge.setAttribute('aria-hidden', 'true');
      badge.style.setProperty('display', 'none', 'important');
      badge.style.setProperty('visibility', 'hidden', 'important');
      badge.style.setProperty('opacity', '0', 'important');
    });
  }

  function showDiscountBadge(modal, percentage) {
    percentage = Math.round(Number(percentage || 0));

    if (!modal || !percentage || percentage <= 0) {
      hideDiscountBadge(modal);
      return;
    }

    var positionRoot = getModalPositionRoot(modal);
    var badge = ensureDiscountBadge(modal);

    if (!badge || !positionRoot) return;

    removeWrongQuickViewBadges(modal, badge);

    var percentageElement = badge.querySelector('[data-percentage-value]');

    if (percentageElement) {
      percentageElement.textContent = percentage;
    }

    var rootRect = positionRoot.getBoundingClientRect();
    var stackBadge = getQuickViewStackBadge(modal);
    var position;

    if (forceQuickViewBadgeToImageTopLeft && stackBadge) {
      var plpStackRect = stackBadge.getBoundingClientRect();

      position = {
        top: Math.round(plpStackRect.bottom - rootRect.top + 8),
        left: Math.round(plpStackRect.left - rootRect.left)
      };
    } else if (forceQuickViewBadgeToImageTopLeft) {
      position = getImagePositionInRoot(modal, positionRoot);
    } else if (stackBadge) {
      var stackRect = stackBadge.getBoundingClientRect();

      position = {
        top: Math.round(stackRect.bottom - rootRect.top + 8),
        left: Math.round(stackRect.left - rootRect.left)
      };
    } else {
      position = getImagePositionInRoot(modal, positionRoot);
    }

    badge.style.setProperty('position', 'absolute', 'important');
    badge.style.setProperty('top', position.top + 'px', 'important');
    badge.style.setProperty('left', position.left + 'px', 'important');
    badge.style.setProperty('z-index', '60', 'important');
    badge.style.setProperty('margin', '0', 'important');
    badge.style.setProperty('pointer-events', 'none', 'important');
    badge.style.setProperty('display', 'inline-flex', 'important');
    badge.style.setProperty('visibility', 'visible', 'important');
    badge.style.setProperty('opacity', '1', 'important');
    badge.style.setProperty('transform', 'none', 'important');
    badge.setAttribute('aria-hidden', 'false');
    badge.classList.add('is-visible');
  }
  function updateQuickViewModal(modal, details) {
    if (!modal) return;

    restoreButtonPrices(modal);

    var priceElements = getPriceElements(modal);

    if (!details || !details.code) {
      priceElements.forEach(restorePrice);
      hideDiscountBadge(modal);
      return;
    }

    var code = normalizeCode(details.code);

    getProductIdAsync(modal).then(function(productId) {
      if (!productId) {
        priceElements.forEach(restorePrice);
        hideDiscountBadge(modal);
        return;
      }

      fetchProductDiscount(code, productId).then(function(percentage) {
        if (String(getProductIdFromModal(modal) || '') !== String(productId)) {
          return;
        }

        if (percentage === null) return;

        percentage = Number(percentage || 0);

        if (percentage > 0) {
          priceElements.forEach(function(priceElement) {
            renderPrice(priceElement, percentage, code);
          });

          showDiscountBadge(modal, percentage);
        } else {
          priceElements.forEach(restorePrice);
          hideDiscountBadge(modal);
        }

        restoreButtonPrices(modal);
      }).catch(function() {
        priceElements.forEach(restorePrice);
        hideDiscountBadge(modal);
        restoreButtonPrices(modal);
      });
    });
  }

  function updateAllQuickViews() {
    var details = getActiveDiscountDetails();

    getQuickViewModals().forEach(function(modal) {
      updateQuickViewModal(modal, details);
    });
  }

  function scheduleUpdate(delay, clearCache) {
    if (clearCache) {
      cacheGeneration += 1;
      discountCache = {};
      pendingDiscounts = {};
    }

    clearTimeout(timer);

    timer = setTimeout(function() {
      requestAnimationFrame(function() {
        updateAllQuickViews();
      });
    }, typeof delay === 'number' ? delay : 180);
  }

  function syncQuickViewProductData() {
    document.querySelectorAll('.quick-product--wrap').forEach(function(modal) {
      var content = modal.querySelector('.quick-view-modal__content');
      var quickProduct = modal.querySelector('.quick-product[data-product-id]');
      var form = modal.querySelector('[data-product-form]');
      var addToCartButton = modal.querySelector('[data-add-to-cart][data-id]');
      var productId = quickProduct
        ? quickProduct.getAttribute('data-product-id')
        : (addToCartButton ? addToCartButton.getAttribute('data-id') : '');
      var productHandle = quickProduct
        ? quickProduct.getAttribute('data-product-handle')
        : (form ? form.getAttribute('data-product-handle') : '');

      if (!content) return;

      if (productId) {
        content.setAttribute('data-product-id', productId);
        modal.setAttribute('data-product-id', productId);
      }

      if (productHandle) {
        content.setAttribute('data-product-handle', productHandle);
        modal.setAttribute('data-product-handle', productHandle);
      }
    });
  }

  function triggerUpdate(delay, clearCache) {
    syncQuickViewProductData();
    scheduleUpdate(delay, clearCache);
  }

  function initObserver() {
    var modalSelector = '.quick-product--wrap[data-quick-view-modal], .quick-product--wrap';

    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = mutations.some(function(mutation) {
        if (
          mutation.target &&
          mutation.target.closest &&
          mutation.target.closest('[data-ne-qv-discount-badge], .ne-discount-price-wrapper')
        ) {
          return false;
        }

        if (mutation.type === 'attributes') {
          return !!(
            mutation.target &&
            mutation.target.closest &&
            mutation.target.closest(modalSelector)
          );
        }

        return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('[data-ne-qv-discount-badge], .ne-discount-price-wrapper')) {
            return false;
          }

          return !!(
            (node.closest && node.closest(modalSelector)) ||
            (node.matches && node.matches(modalSelector)) ||
            (node.querySelector && node.querySelector(modalSelector))
          );
        });
      });

      if (shouldUpdate) triggerUpdate(160, false);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'data-price', 'style']
    });
  }

  function init() {
    triggerUpdate(300, false);

    window.addEventListener('resize', function() {
      triggerUpdate(180, false);
    });

    window.addEventListener('ne:discount-code-updated', function() {
      triggerUpdate(220, true);
    });

    window.addEventListener('ne:discount-details-updated', function() {
      triggerUpdate(220, true);
    });

    window.addEventListener('ne:discount-applied-to-cart', function() {
      triggerUpdate(220, true);
    });

    window.addEventListener('ne:discount-code-cleared', function() {
      triggerUpdate(0, true);
    });

    document.addEventListener('discount:updated', function() {
      triggerUpdate(220, true);
    });

    document.addEventListener('quick-view:open', function() {
      triggerUpdate(100, false);
    });

    document.addEventListener('quick-view:opened', function() {
      triggerUpdate(100, false);
    });

    document.addEventListener('quickview:loaded', function() {
      triggerUpdate(0, true);
    });

    document.addEventListener('quick-view:variant-change', function() {
      triggerUpdate(100, false);
    });

    document.addEventListener('modal:open', function() {
      triggerUpdate(100, false);
    });

    document.addEventListener('click', function(event) {
      if (
        event.target.closest('[data-quick-view]') ||
        event.target.closest('[data-open-quick-view]') ||
        event.target.closest('[data-quick-view-trigger]') ||
        event.target.closest('.quick-view-trigger') ||
        event.target.closest('.product-item') ||
        event.target.closest('.product-card')
      ) {
        triggerUpdate(450, false);
      }
    }, true);

    document.addEventListener('change', function(event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest('.quick-product--wrap')
      ) {
        triggerUpdate(120, false);
      }
    }, true);

    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  })();
